import { type AuthToken } from '@reliance/types/models/Auth';
import { type CaseReport } from '@reliance/types/models/CaseReport';
import { type CaseReportFilters } from '@reliance/types/filters/CaseReportFilters';
import { type CaseReportStatus } from '@reliance/types/enums/CaseReportStatus';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import {
  type ApiSuccessResponse,
  type ApiService,
  type RequestOptions,
} from '../types/ApiService';
import config from '../services/config.ts';

export type CaseReportDeleteOptions = RequestOptions;

export type CaseReportPutItemsRequest = {
  addingCaseReportIds?: number[];
  removingCaseReportIds?: number[];
  textMessageId: number | null;
  cdrId: number | null;
  notes?: string;
};

export type CaseReportUpdateRequest = {
  name?: string;
};

export const caseReports = (
  centralApi: ApiService,
  getToken: () => AuthToken,
) => ({
  index: (
    params?: Partial<CaseReportFilters>,
  ): Promise<PaginatedResponse<CaseReport>> => {
    return centralApi.get<PaginatedResponse<CaseReport>>(`/case-report`, {
      params,
    });
  },
  get: (id: string): Promise<CaseReport> => {
    return centralApi.get<CaseReport>(`/case-report/${id}`, {});
  },
  post: (data: CaseReportUpdateRequest): Promise<ApiSuccessResponse<void>> => {
    return centralApi.post('/case-report', data);
  },
  put: (
    id: number,
    data: CaseReportUpdateRequest,
  ): Promise<ApiSuccessResponse<void>> => {
    return centralApi.put(`/case-report/${id}`, data);
  },
  delete: (
    id: number,
    options?: CaseReportDeleteOptions,
  ): Promise<ApiSuccessResponse<void>> => {
    return centralApi.delete(`/case-report/${id}`, options);
  },
  putItems: (
    data: CaseReportPutItemsRequest,
  ): Promise<ApiSuccessResponse<void>> => {
    return centralApi.put('/case-report/items', data);
  },
  putNotes: (
    id: number,
    data: { notes: string },
  ): Promise<ApiSuccessResponse<void>> => {
    return centralApi.put(`/case-report/${id}/notes`, data);
  },
  putStatus: (
    id: number,
    data: { newStatus: CaseReportStatus },
  ): Promise<ApiSuccessResponse<void>> => {
    return centralApi.put(`/case-report/${id}/status`, data);
  },
  getDownloadUrl: (id: number | string): string => {
    return `${config.centralApi.url}/case-report/${id}/download?token=${
      getToken().accessToken
    }`;
  },
});
